











import { Component, Prop, Vue } from 'vue-property-decorator';
import Title from '../title';

@Component({
  components: {
    Title,
  },
})
export default class Familiarize extends Vue {
  @Prop({ type: String, default: '' })
  readonly title!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/itemsblock/components/familiarize/Familiarize.vue